import { useLocationCapabilities, useStylingCapabilities, useVisibilityCapabilities } from './native-capabilities';

/*
There is no sharp distinctction between a capability and a native capability.
Native capabilities have handlers built into the library so that consumers don't
have to reimplement basic functionalities like opening/closing the component,
restyling it or performing browser navigation.

When a native capability is performs component-related action (e.g. changing its
visibility or style) by default it will operate on `source` property, referring
to the origin component's name.
*/
export const useNativeCapabilities = () => {
  useLocationCapabilities();
  useStylingCapabilities();
  useVisibilityCapabilities();
};